import { useTranslation } from "react-i18next";
import { View } from "react-native";

import ListTable from "../../base/table/listTable";
import ContentBox from "../../base/tamplate/ContentBox";

import { ListFilter } from "../../base/table/listTableType";

import { actionMenus } from "./DeploymentData";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";

interface DeploymentMgmtProps extends ContentContainerProps {
    clickActionMenu: Function;
    selectRow: Function;
    clickRow: Function;
    fetchData: any;
    currentPage : number;
    pageCount: number;
    headers: any;
    tableData: any;
    totalItemCount: number;
    refreshYn: boolean;
}

export default function DeploymentMgmt(props:DeploymentMgmtProps) {
    const { t } = useTranslation();

    return (
        <ContentBox title={t("DEPLOYMENT_MGMT_TITLE")} subtitle={t("DEPLOYMENT_MGMT_SUBTITLE")} infoText={props.infoText} infoError={props.infoError}>
            <View style={{backgroundColor: "#fff"}}>
                <ListTable
                    id={"DeploymentMgmt"}
                    actionMenus={actionMenus}
                    actionMenuClickCb={props.clickActionMenu}
                    searchBarYn={true}
                    searchBarPlaceholder={t("DEPLOYMENT_SEARCH_BAR_PLACEHOLDER_TEXT")}
                    pageYn={true}
                    rowCheckYn={true}
                    rowCheckCb={props.selectRow}
                    rowClickCb={props.clickRow}
                    fetchDataCb={props.fetchData}
                    currentPage={props.currentPage}
                    pageCount={props.pageCount}
                    pageSize={20}
                    tableHeaders={props.headers}
                    tableData={props.tableData}
                    totalItemCount={props.totalItemCount}
                    detailYn={true}
                    refreshYn={props.refreshYn}
                    canLoadYn={true}
                />
            </View>
        </ContentBox>
    )
}